import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
const ProfilerDummy = ({
  children
}) => /*#__PURE__*/_jsx(_Fragment, {
  children: children
});
export { ProfilerDummy };
//# sourceMappingURL=ProfilerDummy.js.map